/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction } from '@angular/fire/compat/database';

export interface LocalSnapshot<T> {
	val: () => T;
	key: string;
	exists: () => boolean;
}

/** more permissive variant of angularfire action, angular fire actually can only have type 'child_x' etc, this one accepts any string */
export interface LocalAction<T> extends Omit<AngularFireAction<T>, 'type'> {
	type: string;
}

//some stuff to "ease" the transition from all the firebaseLists relying on a type that depends on a db update
//roughly replicates the existing db api
export function makeLocalSnapshot<T>(val: T, key: string): LocalSnapshot<T> {
	return {
		val: () => val,
		key,
		exists: () => true,
	};
}
export function makeLocalAction<T = any>(val: T, key: string, type: string): LocalAction<LocalSnapshot<T>> {
	return {
		payload: makeLocalSnapshot<T>(val, key),
		type,
		key,
		prevKey: null, //always null when adding
	};
}
